import { DbRef } from "./firebase";
import { GenericStatusInfoTitle } from "./status";
export const LAB_DRAW_TASK_ID = 'f97yqdoef1fl01lm8hb';
export const LAB_DRAW_TASK_TYPE_ID = '2q3pi9eao0dliioeyn3';
export var ProcedureStatus;
(function (ProcedureStatus) {
    /**
     * All required Procedure data is stored
     */
    ProcedureStatus["CREATED"] = "created";
    /**
     * Clinician has started the procedure
     */
    ProcedureStatus["IN_PROGRESS"] = "inProgress";
    /**
     * Procedure was successfully executed
     */
    ProcedureStatus["COMPLETED"] = "completed";
    /**
     * Procedure is canceled
     */
    ProcedureStatus["CANCELED"] = "canceled";
    /**
     * Procedure execution failed
     */
    ProcedureStatus["FAILED"] = "failed";
    /**
     * Procedure is in draft
     */
    ProcedureStatus["DRAFT"] = "draft";
})(ProcedureStatus || (ProcedureStatus = {}));
/**
 * Detailed status considering other data sources returned from cloud.
 */
export var ProcedureComputedStatus;
(function (ProcedureComputedStatus) {
    /** Patient has created request */
    ProcedureComputedStatus["PATIENT_REQUEST"] = "patientRequest";
    /** Doctor has created request */
    ProcedureComputedStatus["DOCTOR_REQUEST"] = "doctorRequest";
    /** Procedure has all required information from patient and doctor. */
    ProcedureComputedStatus["CREATED"] = "created";
    /** Procedure has been assigned to itinerary */
    ProcedureComputedStatus["IN_ITINERARY"] = "inItinerary";
    /** Nurse has accepted the itinerary */
    ProcedureComputedStatus["CONFIRMED"] = "confirmed";
    /** Nurse in transit to procedure location */
    ProcedureComputedStatus["TRANSIT_PATIENT"] = "transitPatient";
    /** Nurse is at procedure location */
    ProcedureComputedStatus["AT_PATIENT"] = "atPatient";
    /** Nurse has began the procedure */
    ProcedureComputedStatus["IN_PROGRESS"] = "inProgress";
    /** There is a dropoff waypoint action, but the nurse is not on their way yet */
    ProcedureComputedStatus["AWAITING_DROPOFF"] = "awaitingDropoff";
    /** Nurse is in transit to drop off location */
    ProcedureComputedStatus["TRANSIT_DROPOFF"] = "transitDropoff";
    /** All procedure requirements are met */
    ProcedureComputedStatus["COMPLETED"] = "completed";
    /** Procedure failed */
    ProcedureComputedStatus["FAILED"] = "failed";
    /** Procedure is canceled */
    ProcedureComputedStatus["CANCELED"] = "canceled";
    /** Unable to determine status */
    ProcedureComputedStatus["UNKNOWN"] = "unknown";
})(ProcedureComputedStatus || (ProcedureComputedStatus = {}));
export var ResultStatus;
(function (ResultStatus) {
    /** Result has been entered */
    ResultStatus["COMPLETE"] = "complete";
    /** Result not yet entered */
    ResultStatus["PENDING"] = "pending";
})(ResultStatus || (ResultStatus = {}));
export var ResultName;
(function (ResultName) {
    ResultName["INCONCLUSIVE"] = "inconclusive";
    ResultName["POSITIVE"] = "positive";
    ResultName["NEGATIVE"] = "negative";
})(ResultName || (ResultName = {}));
export var ResultDocumentGenerationError;
(function (ResultDocumentGenerationError) {
    ResultDocumentGenerationError["MISSING_SUBSTITUTIONS"] = "missingSubstitutions";
    ResultDocumentGenerationError["UNKNOWN"] = "unknown";
})(ResultDocumentGenerationError || (ResultDocumentGenerationError = {}));
export var ResultDocumentGenerationStatus;
(function (ResultDocumentGenerationStatus) {
    /** Result document is ready */
    ResultDocumentGenerationStatus["COMPLETE"] = "complete";
    /** Result document generation failed */
    ResultDocumentGenerationStatus["ERROR"] = "error";
    /** Result document is currently loading */
    ResultDocumentGenerationStatus["PENDING"] = "pending";
})(ResultDocumentGenerationStatus || (ResultDocumentGenerationStatus = {}));
export var CancelationUserType;
(function (CancelationUserType) {
    CancelationUserType["NURSE"] = "nurse";
    CancelationUserType["PATIENT"] = "patient";
    CancelationUserType["PRESCRIBER"] = "prescriber";
    CancelationUserType["ASSISTANT"] = "assistant";
    CancelationUserType["CARESEND"] = "caresend";
})(CancelationUserType || (CancelationUserType = {}));
export var CancelationReason;
(function (CancelationReason) {
    CancelationReason["DATE_OR_TIME_NO_LONGER_WORKS"] = "dateOrTimeNoLongerWorks";
    CancelationReason["DISPATCH_ERROR"] = "dispatchError";
    CancelationReason["DRAFT_WAYPOINT_REJECTED"] = "draftWaypointRejected";
    CancelationReason["FACILITY_REFUSAL"] = "facilityRefusal";
    CancelationReason["INFORMATION_ERROR"] = "informationError";
    CancelationReason["IRRELEVANT_PROCEDURE"] = "irrelevantProcedure";
    CancelationReason["KIT_DAMAGED"] = "kitDamaged";
    CancelationReason["KIT_EXPIRED"] = "kitExpired";
    CancelationReason["KIT_MISSING"] = "kitMissing";
    CancelationReason["MEDICAL_NECESSITY"] = "medicalNecessity";
    CancelationReason["NO_KIT"] = "noKit";
    CancelationReason["NO_SHOW"] = "noShow";
    CancelationReason["NURSE_SHIFT_CANCELATION"] = "nurseShiftCancelation";
    CancelationReason["OTHER"] = "other";
    CancelationReason["PATIENT_DECEASED"] = "patientDeceased";
    CancelationReason["PATIENT_NO_SHOW"] = "patientNoShow";
    CancelationReason["PATIENT_REFUSAL"] = "patientRefusal";
    CancelationReason["PATIENT_REQUEST"] = "patientRequest";
    CancelationReason["PATIENT_UNAVAILABLE"] = "patientUnavailable";
    CancelationReason["RESCHEDULE"] = "reschedule";
    CancelationReason["SAMPLE_ALREADY_COLLECTED"] = "sampleAlreadyCollected";
    CancelationReason["SENT_TO_OFFLINE_STAFFING"] = "sentToOfflineStaffing";
    CancelationReason["STAFFING_ISSUE"] = "staffingIssue";
    CancelationReason["SUPPLIES_DAMAGED"] = "suppliesDamaged";
    CancelationReason["SUPPLIES_MISSING"] = "suppliesMissing";
    CancelationReason["SUPPLIES_NOT_PRESENT"] = "suppliesNotPresent";
    CancelationReason["SUPPLY_ISSUE"] = "supplyIssue";
    CancelationReason["SUPPLY_ITEMS_MISSING"] = "supplyItemsMissing";
    CancelationReason["VISIT_NO_LONGER_NEEDED"] = "visitNoLongerNeeded";
    /** Mapped to procedure failure reasons */
    CancelationReason["COLLECTION_FAILED"] = "collectionFailed";
    CancelationReason["DROP_OFF_FAILED"] = "dropOffFailed";
    CancelationReason["VENIPUNCTURE_ISSUE"] = "venipunctureIssue";
})(CancelationReason || (CancelationReason = {}));
export const cancelationReasonFormatted = {
    [CancelationReason.DATE_OR_TIME_NO_LONGER_WORKS]: 'Date or time no longer works',
    [CancelationReason.DISPATCH_ERROR]: 'Dispatch error',
    [CancelationReason.DRAFT_WAYPOINT_REJECTED]: 'Draft waypoint rejected',
    [CancelationReason.FACILITY_REFUSAL]: 'Facility refusal',
    [CancelationReason.INFORMATION_ERROR]: 'Information error',
    [CancelationReason.IRRELEVANT_PROCEDURE]: 'Irrelevant procedure',
    [CancelationReason.KIT_DAMAGED]: 'Kit damaged',
    [CancelationReason.KIT_EXPIRED]: 'Kit expired',
    [CancelationReason.KIT_MISSING]: 'Kit missing',
    [CancelationReason.MEDICAL_NECESSITY]: 'Medical necessity',
    [CancelationReason.NO_KIT]: 'No kit',
    [CancelationReason.NO_SHOW]: 'No show',
    [CancelationReason.NURSE_SHIFT_CANCELATION]: 'Nurse shift cancelation',
    [CancelationReason.OTHER]: 'Other',
    [CancelationReason.PATIENT_DECEASED]: 'Patient deceased',
    [CancelationReason.PATIENT_NO_SHOW]: 'Patient no show',
    [CancelationReason.PATIENT_REFUSAL]: 'Patient refusal',
    [CancelationReason.PATIENT_REQUEST]: 'Patient request',
    [CancelationReason.PATIENT_UNAVAILABLE]: 'Patient unavailable',
    [CancelationReason.RESCHEDULE]: 'Reschedule',
    [CancelationReason.SAMPLE_ALREADY_COLLECTED]: 'Sample already collected',
    [CancelationReason.SENT_TO_OFFLINE_STAFFING]: 'Sent to offline staffing',
    [CancelationReason.STAFFING_ISSUE]: 'Staffing issue',
    [CancelationReason.SUPPLIES_DAMAGED]: 'Supplies damaged',
    [CancelationReason.SUPPLIES_MISSING]: 'Supplies missing',
    [CancelationReason.SUPPLIES_NOT_PRESENT]: 'Supplies not present',
    [CancelationReason.SUPPLY_ISSUE]: 'Supply issue',
    [CancelationReason.SUPPLY_ITEMS_MISSING]: 'Supply items missing',
    [CancelationReason.VISIT_NO_LONGER_NEEDED]: 'Visit no longer needed',
    /** Mapped to procedure failure reasons */
    [CancelationReason.COLLECTION_FAILED]: 'Collection failed',
    [CancelationReason.DROP_OFF_FAILED]: 'Drop off failed',
    [CancelationReason.VENIPUNCTURE_ISSUE]: 'Venipuncture issue',
};
export var SupplyCondition;
(function (SupplyCondition) {
    SupplyCondition["KIT_DAMAGED_MISSING_TUBES"] = "kitDamagedMissingTubes";
    SupplyCondition["SUPPLIES_INTACT"] = "suppliesIntact";
    SupplyCondition["SUPPLIES_LOST"] = "suppliesLost";
    SupplyCondition["SUPPLIES_USED"] = "suppliesUsed";
})(SupplyCondition || (SupplyCondition = {}));
export const procedureStatusFormatted = {
    [GenericStatusInfoTitle.PENDING]: 'Visit pending',
    [GenericStatusInfoTitle.IN_PROGRESS]: 'Procedure in progress',
    [GenericStatusInfoTitle.COLLECTED]: 'Samples collected',
    [GenericStatusInfoTitle.SUBMITTED]: 'Samples dropped off at processing lab',
    [GenericStatusInfoTitle.SUBMITTED_WITH_TRACKING]: 'Sample shipment submitted to processing lab',
    [GenericStatusInfoTitle.DELIVERED]: 'Sample shipment delivered to processing lab',
    [GenericStatusInfoTitle.CANCELED]: 'Procedure canceled',
    [GenericStatusInfoTitle.FAILED]: 'Procedure failed',
};
export const supplyConditionFormatted = {
    [SupplyCondition.KIT_DAMAGED_MISSING_TUBES]: 'Kit damaged/Missing tubes',
    [SupplyCondition.SUPPLIES_INTACT]: 'Supplies intact',
    [SupplyCondition.SUPPLIES_LOST]: 'Supplies lost',
    [SupplyCondition.SUPPLIES_USED]: 'Supplies used',
};
export const supplyConditionLabels = {
    [SupplyCondition.KIT_DAMAGED_MISSING_TUBES]: `
    Kit damaged/Missing tubes means the kit was damaged or missing tubes.
  `,
    [SupplyCondition.SUPPLIES_LOST]: `
    Supplies lost means you or the location couldn’t
    physically locate the supply kits needed for this procedure.
  `,
    [SupplyCondition.SUPPLIES_INTACT]: `
    Supplies intact means there is a sealed CareSend
    kit for this specific patient and procedure
  `,
    [SupplyCondition.SUPPLIES_USED]: `
    Supplies used means the CareSend kit
    for these procedure has been opened
    or tampered with
  `,
};
export var FailureReason;
(function (FailureReason) {
    FailureReason["COLLECTION_FAILED"] = "collectionFailed";
    FailureReason["DROP_OFF_FAILED"] = "dropOffFailed";
    FailureReason["SUPPLY_ISSUE"] = "supplyIssue";
    FailureReason["VENIPUNCTURE_ISSUE"] = "venipunctureIssue";
})(FailureReason || (FailureReason = {}));
export const failureReasonFormatted = {
    [FailureReason.COLLECTION_FAILED]: 'Collection failed',
    [FailureReason.DROP_OFF_FAILED]: 'Drop off failed',
    [FailureReason.SUPPLY_ISSUE]: 'Supply issue',
    [FailureReason.VENIPUNCTURE_ISSUE]: 'Venipuncture issue',
};
export const failureToCancelationMap = {
    [FailureReason.COLLECTION_FAILED]: CancelationReason.COLLECTION_FAILED,
    [FailureReason.DROP_OFF_FAILED]: CancelationReason.DROP_OFF_FAILED,
    [FailureReason.SUPPLY_ISSUE]: CancelationReason.SUPPLY_ISSUE,
    [FailureReason.VENIPUNCTURE_ISSUE]: CancelationReason.VENIPUNCTURE_ISSUE,
};
/** Supply canceled or failed procedure statues that are eligible for reschedule */
export const reschedulableProcedureStatuses = [
    ProcedureStatus.CANCELED,
    ProcedureStatus.FAILED,
];
export var BillTo;
(function (BillTo) {
    BillTo["CLIENT"] = "client";
    BillTo["INSURANCE"] = "insurance";
    BillTo["PATIENT"] = "patient";
})(BillTo || (BillTo = {}));
export var LabPriority;
(function (LabPriority) {
    LabPriority["ROUTINE"] = "Routine";
    LabPriority["STAT"] = "STAT";
})(LabPriority || (LabPriority = {}));
export const ProcedureRelationshipKeys = {
    bookingID: { ref: DbRef.BOOKINGS },
    draftWaypointID: { ref: DbRef.DRAFT_WAYPOINTS },
    dropOffPlaceGroups: { ref: DbRef.PLACE_GROUPS },
    nurseID: { ref: DbRef.USERS },
    orderID: { ref: DbRef.ORDERS },
    placeAccounts: { ref: DbRef.PLACE_ACCOUNTS },
    products: { ref: DbRef.PRODUCTS },
    rescheduledID: { ref: DbRef.PROCEDURES },
    sampleShipmentID: { ref: DbRef.SHIPMENTS },
    supplyItems: { ref: DbRef.SUPPLY_ITEMS },
    supplyTransferID: { ref: DbRef.SUPPLY_TRANSFERS },
    waypointActions: { ref: DbRef.WAYPOINT_ACTIONS },
};
export var AlgoliaProcedureTag;
(function (AlgoliaProcedureTag) {
    AlgoliaProcedureTag["IN_ITINERARY"] = "inItinerary";
    AlgoliaProcedureTag["NOT_IN_ITINERARY"] = "notInItinerary";
})(AlgoliaProcedureTag || (AlgoliaProcedureTag = {}));
export var ProcedureDocumentInfo;
(function (ProcedureDocumentInfo) {
    ProcedureDocumentInfo["MANUAL"] = "manual";
    ProcedureDocumentInfo["AUTO_GENERATED"] = "autoGenerated";
    ProcedureDocumentInfo["AUTO_GENERATED_WITH_FALLBACK"] = "autoGeneratedWithFallback";
})(ProcedureDocumentInfo || (ProcedureDocumentInfo = {}));
export const LabelProcedureDocumentInfo = {
    [ProcedureDocumentInfo.MANUAL]: 'Manual upload',
    [ProcedureDocumentInfo.AUTO_GENERATED]: 'Auto-generated',
    [ProcedureDocumentInfo.AUTO_GENERATED_WITH_FALLBACK]: 'Auto-generated, using fallback test names',
};
//# sourceMappingURL=procedures.js.map